import React from 'react';
import Analytics from '../../utils/Analytics';
import { connect } from 'react-redux';
import { toHHMMSS, htmlDecode } from '../../utils/commonFunctions';
import ErrorModal from '../common/errorModal';
import moment from 'moment';
import Zoom from '../utils/animations/zoom';
import UserTypes from '../../utils/userTypes';
import { tagEvent } from '../../utils/tagManager';
import { dateDiff } from '../../utils/commonFunctions';

const TestHeader = ({
	elementType,
	attemptProgress,
	timeRemaining,
	questionId,
	questionNo,
	questionCount,
	unitName,
	elementName,
	attemptName,
	courseId,
	activeChildId,
	userType,
	course_name,
	previewMode,
	userId,
	product_id,
	product_name,
}) => {
	const trackAnalytics = () => {
		Analytics('closeTestpage', {
			screen: 'testPage',
			action: 'buttonClick',
			info: { question_id: questionId, question_no: questionNo },
			user_id: localStorage.getItem('login_user_id'),
		});
	};

	if (attemptName === 'freedailystep') {
		unitName = 'Your DailySTEP';
		elementName = moment(new Date()).format('D MMM YYYY');
	}

	const [min, sec] = !!timeRemaining
		? toHHMMSS(timeRemaining).split(':')
		: ['00', '00'];

	const previewExit = () => {
		if (previewMode) {
			tagEvent({
				event: 'end_course_preview',
				user_id: userId,
				duration: Math.abs(
					dateDiff('seconds', localStorage.getItem('previewWebisodeStart')),
				),
				activity_name: elementName,
				course_id: courseId,
				grant_name: course_name,
				product_id,
				product_name,
				platform: 'web',
			});
			localStorage.removeItem('previewWebisodeStart');
		}
	};

	return (
		<span>
			<section className="container-fluid">
				<section className="row">
					<section className="quiz-page-header">
						{!!elementType && (elementType === 'S' || elementType === 'F') && (
							<div className="btn btn-icon quiz-timer">
								<div className='quiz-timer-label'>Time remaining</div>
								<div className='quiz-timer-countdown'>
									<strong>
										<span className="minuteLeft">{min}</span>
										{/* <em>mins</em> */}
									</strong>
									<strong>
										<span>:</span>
									</strong>
									<strong>
										<span className="secondsLeft">{sec}</span>
										{/* <em>secs</em> */}
									</strong>
								</div>
							</div>
						)}

						<h3 className="d-none d-sm-none d-md-block">
							{htmlDecode(unitName)}
							<span> &#8594; </span>
							{htmlDecode(elementName)}
							<p className='questionCount-header'><b>{questionNo}</b> of <b>{questionCount}</b> questions</p>
						</h3>
						<h3 className="d-sm-block d-lg-none  d-md-none d-xl-none ">
							{htmlDecode(elementName)}
						</h3>
						<Zoom>
							<a
								href={`${userType === UserTypes.Junior
									? `/junior/dashboard`
									: userType === UserTypes.Parent
										? `/child/dashboard/${activeChildId}`
										: elementType === 'D'
											? '/'
											: '/mycourse'
									}`}
								onClick={() => {
									previewExit();
									trackAnalytics();
								}}
								onTouchStart={trackAnalytics}
								className="btn btn-icon go-back"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Close"
							>
								<i className="fa fa-times  fa-lg" aria-hidden="true"></i>
							</a>
						</Zoom>
						{((!!elementType && elementType !== 'S') ||
							userType === UserTypes.Parent ||
							userType === UserTypes.Junior) && (
								<section className="step-line-progress">
									<span
										className="percentage"
										style={{ width: `${attemptProgress}%` }}
									></span>
								</section>
							)}
					</section>
				</section>
			</section>

			<ErrorModal />
		</span>
	);
};

const mapStateToProps = (state) => {
	const {
		elementType,
		hourglass,
		attemptProgress,
		timeRemaining,
		questionId,
		questionNo,
		questionCount,
		attemptName,
	} = state.rootReducer.testPageDetails;
	const { activeChildId } = state.rootReducer.parentDetails;
	const {
		unitName,
		elementName,
		courseId,
		coursedetails: { course_name } = {},
		previewMode,
	} = state.rootReducer.myCourse;
	const { userType, userId } = state.rootReducer.loginDetails;

	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;

	return {
		elementType,
		hourglass,
		attemptProgress,
		timeRemaining,
		questionId,
		questionNo,
		questionCount,
		unitName,
		elementName,
		attemptName,
		courseId,
		activeChildId,
		userType,
		course_name,
		previewMode,
		userId,
		product_id,
		product_name,
	};
};

export default connect(mapStateToProps)(TestHeader);
